/* FloatingSifter theme JS — mobile nav + FAQ accordion only. */
(function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // FAQ accordion
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-faq-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  // Quantity steppers (product + cart)
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var min = parseInt(input.min || '1', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 0) + 1;
    });
  });
})();
